import { render, staticRenderFns } from "./GetReporting.vue?vue&type=template&id=13e9de4c"
import script from "./GetReporting.vue?vue&type=script&lang=js"
export * from "./GetReporting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports